var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:[`r-icon-button `, { active: _vm.active }]},[_c('r-icon',{attrs:{"name":_vm.icon,"size":_vm.size}}),(_vm.caption)?_c('span',{staticClass:"r-icon-button__caption"},[_vm._v(" "+_vm._s(_vm.caption)+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }